import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlacklistAdministrationComponent } from './component/blacklist-administration.component';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';


@NgModule({
  declarations: [
    BlacklistAdministrationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonUIElementsModule
  ]
})
export class BlacklistAdministrationModule { }
